import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import UserComponent from "../security/UserComponent";
import { ProgramContainer } from "../entities/formTemplateDataType";
import { openHelpDocInNewTab } from "../utilities/HelpDocUtils";
import { OntarioConfirmDialog } from "./OntarioConfirmDialog";

interface Props {
  callback,
  userLoadedCallBack,
  programContainer?: ProgramContainer;
  isFormDirty?: boolean;
  showHelpLink?: boolean;
}

interface State {
  showExitDialog: boolean;
}

export class HeaderComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      showExitDialog: false,
    };
  }

  handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (this.props.programContainer?.HeaderType === "Labour" || this.props.programContainer?.HeaderType === "ServiceOntario") {
      e.preventDefault();

      // Only show exit dialog if:
      // 1. EnableExitPopup is "Y" AND
      // 2. Form is dirty (has unsaved changes)
      if (this.props.programContainer.EnableExitPopup === "Y" && this.props.isFormDirty) {
        this.setState({ showExitDialog: true });
      } else {
        // Navigate away directly if form is not dirty or exit popup is disabled
        window.location.href = "http://www.ontario.ca";
      }
    }
    // If not Labour header, allow default navigation
  }

  handleConfirmExit = () => {
    window.location.href = "http://www.ontario.ca";
  }

  handleCancelExit = () => {
    this.setState({ showExitDialog: false });
  }

  render() {
    return (
      <>
        <div key={'headerkey'}>
          <header className="ontario-header" style={{ height: '90px' }} >
            <div className="ontario-row">
              <div className="ontario-header__logo-container ontario-columns">
                <a href="http://www.ontario.ca" onClick={this.handleLogoClick}>
                  <img id="asap-logo" src={logo} alt="Government of Ontario" />
                </a>
              </div>
              <div className="ontario-header__logo-container ontario-columns" style={{ padding: '0', height: 'auto' }}>
                {/* <span id="headerTitle">
                  {titleString}
                </span> */}
              </div>
            </div>
          </header>
          <header className='ontario-header mainStreetRow' style={{ height: '64px', background: '#0369AC' }}>
            <div className="ontario-row">
              <div
                className="ontario-header__logo-container"
                style={{ padding: '0', height: 'auto', marginRight: 'auto', display: 'flex', alignItems: 'center', flex: 1, flexWrap: 'nowrap' }}
              >
                <span id="headerTitle" style={{ flex: 1, minWidth: 0 }}>
                  <a href="#" onClick={this.props.callback}>
                  <strong
                    className="ontario-application-subheader__heading"
                    style={{ color: 'white', whiteSpace: 'nowrap', display: 'inline-flex' }}
                  >
                    Form Builder
                  </strong>
                  </a>
                </span>
                {this.props.showHelpLink && (
                  <a
                    href="#"
                    aria-label="Open help documentation"
                    title="Open help documentation"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "4px 10px",
                      marginLeft: "10px",
                      borderRadius: "999px",
                      backgroundColor: "#ffffff",
                      color: "#0369AC",
                      fontWeight: 600,
                      textDecoration: "none",
                      border: "1px solid #ffffff",
                      boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.35)",
                      cursor: "pointer",
                    }}
                    onClick={(event) => {
                      event.preventDefault();
                      openHelpDocInNewTab("Help");
                    }}
                  >
                    <svg
                      className="ontario-icon"
                      aria-hidden="true"
                      focusable="false"
                      viewBox="0 0 24 24"
                      style={{ width: "16px", height: "16px", fill: "currentColor" }}
                    >
                      <use href="#ontario-icon-help" />
                    </svg>
                    Help
                  </a>
                )}
              </div>
              <div className="ontario-header__nav-right-container ontario-columns ontario-small-10">
               {/* <a id="language-link"> */}
                  <p className='ontario-application-subheader__heading' style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <a className="not-clickable">
                      <UserComponent
                        isEng={true}
                        categoryId={this.props.programContainer?.CategoryId}
                        scopes={this.props.programContainer?.Scopes}
                        showProfilePicture={true}
                        lockAfterFirstLogin={true}
                        callback={() => this.props.userLoadedCallBack()}
                      />
                    </a>
                  </p>
                {/* </a> */}
              </div>
            </div>
          </header>
        </div>
        {(this.props.programContainer?.HeaderType === "Labour" || this.props.programContainer?.HeaderType === "ServiceOntario") && (
          <OntarioConfirmDialog
            visible={this.state.showExitDialog}
            title={this.props.programContainer?.ExitPopupTitle || "Are you sure you want to exit?"}
            message={this.props.programContainer?.ExitPopupMessage || "If you leave this page your progress will not be saved."}
            cancelLabel={this.props.programContainer?.ExitPopupStayButtonLabel || "Stay on this page"}
            confirmLabel={this.props.programContainer?.ExitPopupExitButtonLabel || "Exit without saving"}
            onCancel={this.handleCancelExit}
            onConfirm={this.handleConfirmExit}
          />
        )}
      </>
    )
  }
}
